module.exports = __webpack_public_path__ + "img/E1 UB2.5de8127c.png";